import React, {useState} from "react";
import Chart from "react-apexcharts";

const Customers = () => {

    const chartOptions = {
        chart: {
            height: 350,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
                // startAngle: -180,
                // endAngle: 180, 
              hollow: {
                size: '48%',
              },
              dataLabels: {
                name: {
                  fontSize: '22px',
                },
                value: {
                  fontSize: '16px',
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter: function (w) {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return 100
                  }
                }
              }
            }
          },
          labels: ['Basavraj P', 'Manjunath D',],
          colors: ['#A093FF', '#FFB199'], // Colors for Female and Male
      };
    
      const chartSeries = [28, 72]; // Values for Female and Male
    
      return (
        <div>
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="radialBar"
            height={250}
          />
        </div>
      );
}

export default Customers;